
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33779',
  depVersions: {
  "documents-public-ui": "static-1.33779",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33784",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1836",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5306",
  "hs-test-utils": "static-1.7698",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11139",
  "I18n": "static-7.1547",
  "jasmine-immutable": "static-1.2733",
  "jasmine-runner": "static-1.6171",
  "lodash": "static-1.3",
  "quartz": "static-1.6601",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16349",
  "reporting-data": "static-1.66171",
  "reporting-testing-lib": "static-1.8104",
  "reporting-visualizations": "static-1.58247",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4459",
  "webpack-env": "static-1.54",
  "atom": "static-1.4787",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2181",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.706",
  "customer-data-filters-ui": "static-1.38585",
  "customer-data-objects": "static-1.7330",
  "customer-data-property-utils": "static-1.7784",
  "data-fetching-client": "static-1.9391",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4249",
  "flux-actions": "static-1.299",
  "FormsCommonComponents": "static-1.85063",
  "FormUrlGenerator": "static-2.4446",
  "foundations-components": "static-1.7345",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11447",
  "icons": "static-2.615",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6859",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3575",
  "property-translator": "static-1.5129",
  "quartz-config": "static-1.379",
  "quartz-core": "static-1.5820",
  "quick-fetch": "static-1.3651",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5099",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7876",
  "reference-resolvers-lite": "static-1.7804",
  "report-customization-components": "static-1.12267",
  "reporting-enablement": "static-1.21803",
  "reporting-reports": "static-1.65849",
  "reporting-snowflake": "static-1.54789",
  "reporting-ui-components": "static-2.63443",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4322",
  "sales-content-partitioning": "static-1.8649",
  "SalesContentIndexUI": "static-3.8763",
  "sanitize": "static-1.4190",
  "sanitize-text": "static-1.7855",
  "self-service-api": "static-1.9942",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1463",
  "signup-constants": "static-1.18233",
  "signup-ui-lego-core": "static-1.20243",
  "signup-ui-url-generator": "static-2.7748",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4488",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10711",
  "ui-addon-i18n": "static-1.10843",
  "ui-addon-react-router-dom": "static-1.9262",
  "ui-addon-upgrades": "static-9.17439",
  "ui-asset-management-lib": "static-1.10580",
  "ui-images": "static-2.1067",
  "UIComponents": "static-3.8086",
  "usage-tracker": "static-1.7050",
  "usage-tracker-container": "static-1.7040",
  "usage-tracker-core": "static-1.6900",
  "usage-tracker-public": "static-1.6861",
  "viral-links-lib": "static-1.6737",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3150",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2878",
  "quartz-webpack": "static-1.2825",
  "ai-components-ui-library": "static-1.8130",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4547",
  "foundations-theming": "static-1.4120",
  "quartz-auth": "static-1.276",
  "usage-tracker-session-replay": "static-1.4736",
  "foundations-theming-base": "static-1.3105",
  "HeadJS": "static-2.695",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2809",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4046",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7639",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3383",
  "persist-promise": "static-1.3402",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9142",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9254",
  "hubspotter-http": "static-1.4401",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6966",
  "crm-message-bus": "static-1.42136",
  "customer-data-filters-ui-msw-helpers": "static-1.21019",
  "customer-data-objects-ui-components": "static-1.12717",
  "customer-data-reference-ui-components": "static-1.12854",
  "customer-data-ui-utilities": "static-1.9541",
  "framework-builder-read-service-client": "static-1.3770",
  "framework-data-schema-quick-fetch": "static-1.6489",
  "framework-data-schema-resolvers": "static-1.6584",
  "inbound-db-properties-service-client": "static-1.3602",
  "multi-account-reference-resolvers": "static-1.682",
  "onboarding-tours": "static-1.16155",
  "reporting-datasets-permissions-lib": "static-1.12779",
  "ui-addon-teams": "static-1.21108",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67377",
  "customer-data-properties": "static-1.50530",
  "forms-ai-lib": "static-1.3864",
  "forms-utils-lib": "static-1.12009",
  "foundations-components-test-utils": "static-1.4828",
  "react-dnd-compat": "static-1.4339",
  "react-tinymce": "static-1.54403",
  "tinymce-config": "static-2.53529",
  "ui-gdpr-components": "static-1.10061",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3614",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1001",
  "ui-fonts": "static-1.401",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.776",
  "mobile-manifest-mixins": "static-1.468",
  "quartz-head": "static-1.266",
  "quartz-i18n": "static-1.276",
  "quartz-routing": "static-1.31",
  "quartz-test": "static-1.276",
  "batch-promise": "static-1.1245",
  "external-options-client-types": "static-1.3906",
  "react-colorpicker": "static-2.9928",
  "copilot-toolkit": "static-1.10322",
  "data-quality-ui-library": "static-1.12130",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40461",
  "reporting-insights-lib": "static-1.924",
  "reporting-plugins": "static-1.9877",
  "ui-addon-draggable-compat": "static-2.3969",
  "ui-addon-opt": "static-4.8104",
  "ui-shepherd-react": "static-3.9859",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24493",
  "hubspot-apollo-client": "static-1.4595",
  "sales-templates-service-types-lib": "static-1.3916",
  "ui-business-units-lib": "static-1.8737",
  "merchandise-lib": "static-1.255",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5350",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3827",
  "upgrade-management-service-types": "static-1.4223",
  "timezone-utils": "static-2.4959",
  "bender-build-tools": "static-1.2832",
  "chatspot-core": "static-1.20019",
  "chirp-fetch": "static-1.1597",
  "bend-plugin-foundations-theming": "static-1.2603",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9252",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3546",
  "crm-pipelines-api-client-types": "static-1.3888",
  "multi-currency-client-types": "static-1.3444",
  "getting-started-shared-tasks": "static-1.17648",
  "growth-data-modal": "static-1.5048",
  "growth-onboarding-confetti": "static-1.2766",
  "growth-onboarding-next-action-utils": "static-1.1209",
  "navigation-components": "static-1.17027",
  "onboarding-tours-client": "static-1.4369",
  "onboarding-tours-utils": "static-1.221",
  "ui-shepherd-tracker": "static-1.7240",
  "ui-universal-auth": "static-1.8582",
  "user-context": "static-1.4810",
  "cms-field-types": "static-1.4522",
  "content-icons-ui": "static-1.2125",
  "integrations-lib": "static-1.15145",
  "calling-global-api": "static-1.63390",
  "calling-internal-common": "static-1.31004",
  "calling-lifecycle-internal": "static-1.64772",
  "calling-lifecycle-messages": "static-1.57066",
  "commerce-products-lib": "static-1.8594",
  "crm-links": "static-1.5967",
  "file-manager-components": "static-1.22648",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.374",
  "inbounddb-objects-service-types": "static-1.3973",
  "meetings-icalendar-utils-lib": "static-1.349",
  "object-builder-ui-client": "static-1.47709",
  "pipeline-validation-client-types": "static-1.3710",
  "property-value-citations": "static-1.1144",
  "pulse": "static-1.209",
  "smart-property-lib": "static-1.5604",
  "tiered-pricing": "static-1.689",
  "ui-addon-iframeable": "static-1.8736",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19316",
  "tinymce-themes": "static-1.55499",
  "data-token-picker": "static-1.15913",
  "hub-http-contrib": "static-1.2760",
  "interframe": "static-3.4507",
  "tinymce-data": "static-1.39614",
  "tinymce-plugins": "static-1.56643",
  "ui-addon-sales-email": "static-1.4929",
  "magpie-lib": "static-1.5290",
  "magpie-types": "static-1.4750",
  "simple-logging-lib": "static-1.2766",
  "content-assistance-lib": "static-1.7325",
  "dashboard-lib": "static-1.80297",
  "ExportDialog": "static-6.10104",
  "hubspot-prosemirror": "static-1.17374",
  "hubspot-prosemirror-plugins": "static-1.17366",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8404",
  "campaign-roi-lib": "static-1.8032",
  "feedback-loader": "static-1.28704",
  "commerce-analytics-service-client": "static-1.3404",
  "onboarding-scopes": "static-1.6158",
  "apollo-link-hub-http": "static-2.4364",
  "hubspot-apollo-cache": "static-1.54",
  "growth-monetization-service-types": "static-1.4239",
  "nav-client-types": "static-1.2047",
  "purchase-motions-api": "static-1.5353",
  "trials-service-types": "static-1.3640",
  "chatspot-client-types": "static-1.10371",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.441",
  "getting-started-shared-tasks-store": "static-1.16766",
  "cohere-reconnect-lib": "static-1.95",
  "gemini-reconnect-lib": "static-1.55",
  "integrations-error-boundary-lib": "static-1.12560",
  "integrations-tracking-lib": "static-1.5299",
  "native-integrations-shared-strings": "static-1.7503",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10088",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31010",
  "shared-worker-versioning": "static-1.10732",
  "calling-usage-tracker": "static-1.6254",
  "calling-orchestration-shared-library": "static-1.34549",
  "customer-data-tracking": "static-1.6577",
  "products-iframe-lib": "static-1.7112",
  "products-ui-components-shared-msw-handlers": "static-1.9636",
  "location-customization-utils-lib": "static-1.8296",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3871",
  "video-components-external": "static-1.10309",
  "video-data-lib": "static-1.33967",
  "directed-graph": "static-1.652",
  "event-emitter": "static-1.640",
  "breeze-intelligence-kit": "static-1.5195",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9337",
  "fsm": "static-1.3446",
  "policy-lib": "static-1.6516",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9400",
  "navigation-messaging": "static-1.6354",
  "FileManagerLib": "static-1.38288",
  "NamespacedHubStyle": "static-2.8821",
  "FileManagerCore": "static-1.38147",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11886",
  "layout-dnd-utils": "static-1.10861",
  "react-codemirror": "static-1.10320",
  "ui-addon-emoji-picker": "static-1.9605",
  "ui-brand-identity-lib": "static-1.13477",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27721",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8281",
  "payment-link-components": "static-1.22703",
  "EmailSignatureEditor": "static-1.23776",
  "eligibility-engine-service-types": "static-1.2921",
  "universal-page-editor-lib": "static-1.2711",
  "calling-orchestration-schema": "static-1.34774",
  "sales-views-client-types": "static-1.4008",
  "crm-record-cards-service-types": "static-1.3374",
  "content-media-composition-data-lib": "static-1.11114",
  "content-media-compositions": "static-2.15121",
  "media-bridge-lib": "static-1.18435",
  "trellis-story-utils": "static-1.4237",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5489",
  "FileManagerImages": "static-1.35799",
  "video-components": "static-1.12312",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4249",
  "video-embed": "static-1.34801",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67452",
  "layout-data-lib": "static-1.9186",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6301",
  "commerce-tours-lib": "static-1.5583",
  "growth-onboarding-reliability": "static-1.4803",
  "sales-checkout-service-client": "static-1.3416",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21153",
  "sales-email-signature-service-client": "static-1.3557",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21128",
  "outpost": "static-1.3927",
  "advanced-menus-core": "static-1.14677",
  "advanced-menus-lib": "static-1.11666",
  "ui-memberships-settings-lib": "static-1.33206",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14676",
  "simple-menus-lib": "static-1.16193"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33779",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33784",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1836",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5306",
  "hs-test-utils": "/hs-test-utils/static-1.7698",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11139",
  "I18n": "/I18n/static-7.1547",
  "jasmine-immutable": "/jasmine-immutable/static-1.2733",
  "jasmine-runner": "/jasmine-runner/static-1.6171",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6601",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16349",
  "reporting-data": "/reporting-data/static-1.66171",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8104",
  "reporting-visualizations": "/reporting-visualizations/static-1.58247",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4459",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4787",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2181",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.706",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38585",
  "customer-data-objects": "/customer-data-objects/static-1.7330",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7784",
  "data-fetching-client": "/data-fetching-client/static-1.9391",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4249",
  "flux-actions": "/flux-actions/static-1.299",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85063",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4446",
  "foundations-components": "/foundations-components/static-1.7345",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11447",
  "icons": "/icons/static-2.615",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6859",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3575",
  "property-translator": "/property-translator/static-1.5129",
  "quartz-config": "/quartz-config/static-1.379",
  "quartz-core": "/quartz-core/static-1.5820",
  "quick-fetch": "/quick-fetch/static-1.3651",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5099",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7876",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7804",
  "report-customization-components": "/report-customization-components/static-1.12267",
  "reporting-enablement": "/reporting-enablement/static-1.21803",
  "reporting-reports": "/reporting-reports/static-1.65849",
  "reporting-snowflake": "/reporting-snowflake/static-1.54789",
  "reporting-ui-components": "/reporting-ui-components/static-2.63443",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4322",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8649",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8763",
  "sanitize": "/sanitize/static-1.4190",
  "sanitize-text": "/sanitize-text/static-1.7855",
  "self-service-api": "/self-service-api/static-1.9942",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1463",
  "signup-constants": "/signup-constants/static-1.18233",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20243",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7748",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4488",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10711",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10843",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9262",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17439",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10580",
  "ui-images": "/ui-images/static-2.1067",
  "UIComponents": "/UIComponents/static-3.8086",
  "usage-tracker": "/usage-tracker/static-1.7050",
  "usage-tracker-container": "/usage-tracker-container/static-1.7040",
  "usage-tracker-core": "/usage-tracker-core/static-1.6900",
  "usage-tracker-public": "/usage-tracker-public/static-1.6861",
  "viral-links-lib": "/viral-links-lib/static-1.6737",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3150",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2878",
  "quartz-webpack": "/quartz-webpack/static-1.2825",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8130",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4547",
  "foundations-theming": "/foundations-theming/static-1.4120",
  "quartz-auth": "/quartz-auth/static-1.276",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4736",
  "foundations-theming-base": "/foundations-theming-base/static-1.3105",
  "HeadJS": "/HeadJS/static-2.695",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2809",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4046",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7639",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3383",
  "persist-promise": "/persist-promise/static-1.3402",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9142",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9254",
  "hubspotter-http": "/hubspotter-http/static-1.4401",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6966",
  "crm-message-bus": "/crm-message-bus/static-1.42136",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21019",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12717",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12854",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9541",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3770",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6489",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6584",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3602",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.682",
  "onboarding-tours": "/onboarding-tours/static-1.16155",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12779",
  "ui-addon-teams": "/ui-addon-teams/static-1.21108",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67377",
  "customer-data-properties": "/customer-data-properties/static-1.50530",
  "forms-ai-lib": "/forms-ai-lib/static-1.3864",
  "forms-utils-lib": "/forms-utils-lib/static-1.12009",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4828",
  "react-dnd-compat": "/react-dnd-compat/static-1.4339",
  "react-tinymce": "/react-tinymce/static-1.54403",
  "tinymce-config": "/tinymce-config/static-2.53529",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10061",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3614",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1001",
  "ui-fonts": "/ui-fonts/static-1.401",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.776",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.468",
  "quartz-head": "/quartz-head/static-1.266",
  "quartz-i18n": "/quartz-i18n/static-1.276",
  "quartz-routing": "/quartz-routing/static-1.31",
  "quartz-test": "/quartz-test/static-1.276",
  "batch-promise": "/batch-promise/static-1.1245",
  "external-options-client-types": "/external-options-client-types/static-1.3906",
  "react-colorpicker": "/react-colorpicker/static-2.9928",
  "copilot-toolkit": "/copilot-toolkit/static-1.10322",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12130",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40461",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.924",
  "reporting-plugins": "/reporting-plugins/static-1.9877",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3969",
  "ui-addon-opt": "/ui-addon-opt/static-4.8104",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9859",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24493",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4595",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3916",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8737",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5350",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3827",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4223",
  "timezone-utils": "/timezone-utils/static-2.4959",
  "bender-build-tools": "/bender-build-tools/static-1.2832",
  "chatspot-core": "/chatspot-core/static-1.20019",
  "chirp-fetch": "/chirp-fetch/static-1.1597",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2603",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9252",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3546",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3888",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3444",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17648",
  "growth-data-modal": "/growth-data-modal/static-1.5048",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2766",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1209",
  "navigation-components": "/navigation-components/static-1.17027",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4369",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.221",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7240",
  "ui-universal-auth": "/ui-universal-auth/static-1.8582",
  "user-context": "/user-context/static-1.4810",
  "cms-field-types": "/cms-field-types/static-1.4522",
  "content-icons-ui": "/content-icons-ui/static-1.2125",
  "integrations-lib": "/integrations-lib/static-1.15145",
  "calling-global-api": "/calling-global-api/static-1.63390",
  "calling-internal-common": "/calling-internal-common/static-1.31004",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64772",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57066",
  "commerce-products-lib": "/commerce-products-lib/static-1.8594",
  "crm-links": "/crm-links/static-1.5967",
  "file-manager-components": "/file-manager-components/static-1.22648",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.374",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3973",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.349",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47709",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3710",
  "property-value-citations": "/property-value-citations/static-1.1144",
  "pulse": "/pulse/static-1.209",
  "smart-property-lib": "/smart-property-lib/static-1.5604",
  "tiered-pricing": "/tiered-pricing/static-1.689",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8736",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19316",
  "tinymce-themes": "/tinymce-themes/static-1.55499",
  "data-token-picker": "/data-token-picker/static-1.15913",
  "hub-http-contrib": "/hub-http-contrib/static-1.2760",
  "interframe": "/interframe/static-3.4507",
  "tinymce-data": "/tinymce-data/static-1.39614",
  "tinymce-plugins": "/tinymce-plugins/static-1.56643",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4929",
  "magpie-lib": "/magpie-lib/static-1.5290",
  "magpie-types": "/magpie-types/static-1.4750",
  "simple-logging-lib": "/simple-logging-lib/static-1.2766",
  "content-assistance-lib": "/content-assistance-lib/static-1.7325",
  "dashboard-lib": "/dashboard-lib/static-1.80297",
  "ExportDialog": "/ExportDialog/static-6.10104",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17374",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17366",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8404",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8032",
  "feedback-loader": "/feedback-loader/static-1.28704",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3404",
  "onboarding-scopes": "/onboarding-scopes/static-1.6158",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4364",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.54",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4239",
  "nav-client-types": "/nav-client-types/static-1.2047",
  "purchase-motions-api": "/purchase-motions-api/static-1.5353",
  "trials-service-types": "/trials-service-types/static-1.3640",
  "chatspot-client-types": "/chatspot-client-types/static-1.10371",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.441",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16766",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.95",
  "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.55",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12560",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5299",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7503",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10088",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31010",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10732",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6254",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34549",
  "customer-data-tracking": "/customer-data-tracking/static-1.6577",
  "products-iframe-lib": "/products-iframe-lib/static-1.7112",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9636",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8296",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3871",
  "video-components-external": "/video-components-external/static-1.10309",
  "video-data-lib": "/video-data-lib/static-1.33967",
  "directed-graph": "/directed-graph/static-1.652",
  "event-emitter": "/event-emitter/static-1.640",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5195",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9337",
  "fsm": "/fsm/static-1.3446",
  "policy-lib": "/policy-lib/static-1.6516",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9400",
  "navigation-messaging": "/navigation-messaging/static-1.6354",
  "FileManagerLib": "/FileManagerLib/static-1.38288",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8821",
  "FileManagerCore": "/FileManagerCore/static-1.38147",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11886",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10861",
  "react-codemirror": "/react-codemirror/static-1.10320",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9605",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13477",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27721",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8281",
  "payment-link-components": "/payment-link-components/static-1.22703",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23776",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2921",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2711",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34774",
  "sales-views-client-types": "/sales-views-client-types/static-1.4008",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3374",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11114",
  "content-media-compositions": "/content-media-compositions/static-2.15121",
  "media-bridge-lib": "/media-bridge-lib/static-1.18435",
  "trellis-story-utils": "/trellis-story-utils/static-1.4237",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5489",
  "FileManagerImages": "/FileManagerImages/static-1.35799",
  "video-components": "/video-components/static-1.12312",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4249",
  "video-embed": "/video-embed/static-1.34801",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67452",
  "layout-data-lib": "/layout-data-lib/static-1.9186",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6301",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5583",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4803",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3416",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21153",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3557",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "outpost": "/outpost/static-1.3927",
  "advanced-menus-core": "/advanced-menus-core/static-1.14677",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11666",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33206",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14676",
  "simple-menus-lib": "/simple-menus-lib/static-1.16193"
}
};
